export const handleApiError = (error) => {
    if (!error?.response) {
        return {
            type: 'error',
            message: 'Ошибка сети',
            description: ['Не удалось подключиться к серверу']
        };
    }

    const { status, data } = error.response;

    const pickMessages = (payload) => {
        if (!payload) return ['Произошла ошибка'];

        if (Array.isArray(payload)) {
            return payload.map((e) => e?.msg || e?.message || String(e)).filter(Boolean);
        }

        if (typeof payload === 'object') {
            if (payload.message) return [String(payload.message)];
            if (payload.error) return [String(payload.error)];
            if (payload.errors && Array.isArray(payload.errors)) {
                return payload.errors.map((e) => e?.msg || e?.message || String(e)).filter(Boolean);
            }
            return [JSON.stringify(payload)];
        }

        return [String(payload)];
    };

    switch (status) {
        case 400:
            return {
                type: 'error',
                message: 'Ошибка запроса',
                description: pickMessages(data)
            };
        case 401:
            return {
                type: 'error',
                message: 'Ошибка авторизации',
                description: pickMessages(data)
            };
        case 403:
            return {
                type: 'error',
                message: 'Доступ запрещен',
                description: pickMessages(data)
            };
        case 404:
            return {
                type: 'error',
                message: 'Не найдено',
                description: pickMessages(data)
            };
        case 500:
            return {
                type: 'error',
                message: 'Ошибка сервера',
                description: pickMessages(data)
            };
        default:
            return {
                type: 'error',
                message: 'Неизвестная ошибка',
                description: pickMessages(data)
            };
    }
};